<template>
	<SOSlotBase
		:bg-white="true"
		:loading="pageSetting.loading"
	>
		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="pageSetting.pageTitle"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="p-x-20 p-y-16">
				<div class="f-regular f-12 f-c-blue">Transfer Kas</div>
				<div class="f-bold f-18 f-c-black" v-if="payload.ref_type === 'keuangan_transfer'">
					Transfer Kas Bank
				</div>
				<div class="f-bold f-18 f-c-black" v-if="payload.ref_type === 'keuangan_entry'">
					Entry Manual
				</div>
				<div class="f-bold f-18 f-c-black" v-if="payload.ref_type === 'keuangan_prive'">
					Pengambilan Prive
				</div>
				<div class="f-bold f-18 f-c-black" v-if="payload.ref_type === 'keuangan_modal'">
					Setoran Modal
				</div>
				<div class="f-regular f-12 f-c-midgrey">
					<img src="@/assets/icons/clock.svg" alt="" class="m-r-4">
					Dibuat {{ $moment(detailSetoran.created_at).format("DD MMM YYYY HH:mm") }} oleh {{ detailSetoran.pembuat }}
				</div>
			</div>

			<div class="separator-line-dot"></div>

			<div class="p-x-20 p-y-16">
				<div class="d-flex-between-center m-d-8">
					<div class="f-regular f-16 f-c-midgrey">
						Dari akun
					</div>
					<div class="f-regular f-16 f-c-black">
						{{ detailSetoran.akun_kredit }}
					</div>
				</div>
				<div class="d-flex-between-center m-d-8">
					<div class="f-regular f-16 f-c-midgrey">
						Ke akun
					</div>
					<div class="f-regular f-16 f-c-black">
						{{ detailSetoran.akun_debet }}
					</div>
				</div>
				<div class="d-flex-between-center m-d-8">
					<div class="f-regular f-16 f-c-midgrey">
						Nominal
					</div>
					<div class="f-regular f-16 f-c-black">
						Rp. {{ formatRupiah(detailSetoran.nominal.toString()) }}
					</div>
				</div>
				<div class="d-flex-between-center">
					<div class="f-regular f-16 f-c-midgrey" v-if="payload.ref_type === 'keuangan_transfer'">
						Tgl transfer
					</div>
					<div class="f-regular f-16 f-c-midgrey" v-if="payload.ref_type === 'keuangan_entry'">
						Tgl penggunaan
					</div>
					<div class="f-regular f-16 f-c-midgrey" v-if="payload.ref_type === 'keuangan_prive'">
						Tgl pengambilan
					</div>
					<div class="f-regular f-16 f-c-midgrey" v-if="payload.ref_type === 'keuangan_modal'">
						Tgl setor
					</div>
					<div class="f-regular f-16 f-c-black">
						{{ $moment(detailSetoran.tanggal_transfer).format("dddd, DD MMM YYYY HH:mm") }}
					</div>
				</div>
			</div>

			<div class="p-x-20 p-d-16" v-if="detailSetoran.keterangan !== ''">
				<div class="f-regular f-14 f-c-midgrey">
					Keterangan
				</div>
				<div class="f-regular f-14 f-c-black">
					{{ detailSetoran.keterangan }}
				</div>
			</div>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

export default {
	name: "RekeningBankDetailSetoran",
	components: {
		SOSlotBase,
		SOLoadingPage,
		SOTitleBar,
	},
	computed: {
		...mapGetters("rekeningBankModule", {
			detailSetoran: "getRiwayatTransferDetail",
		})
	},
	data() {
		return {
			payload: {
				ref_id: "",
				ref_type: "",
			},
			pageSetting: {
				pageTitle: "Detail Setoran",
				loading: true,
			}
		}
	},
	mounted() {
		this.payload.ref_id = this.$route.params.ref_id
		this.payload.ref_type = this.$route.params.ref_type

		this.detail()
	},
	methods: {
		back() {
			this.$router.back()
		},
		async detail() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("rekeningBankModule/fetchRiwayatTransferDetail", this.payload)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.error)
				this.back()
			}
		}
	}
}
</script>